export default "__VITE_ASSET__b72ddb96__"